import React from 'react';
import { Box, Flex, Heading, Text } from '@chakra-ui/react';

const NoResultsView = () => (
  <Box p={4}>
    <Flex direction="column" align="center" p={4}>
      <Heading size="md" mb={4}>
        No customer found. Would you like to create a new one?
      </Heading>
      <Text mb={2}>
        Click on <b>'Create New Customer'</b> to create a customer.
      </Text>
    </Flex>
  </Box>
);

export default NoResultsView;
